import React from 'react';

export const isContactCloudLocked = (cloud) => {
    return cloud?.is_locked === true;
};

const ZohoStatus = ({ zohoCloud }) => {
  if (!zohoCloud) {
    return null;
  }

  const isZohoSynced = !!zohoCloud?.is_updated && !!zohoCloud?.external_id;

  return (
    <span className="d-inline-flex align-items-center gap-1" title={isZohoSynced ? 'Synced to Zoho' : 'Not synced to Zoho'}>
      {isZohoSynced ? (
        <i className="fas fa-check-circle text-success" style={{ fontSize: '1.1rem' }} />
      ) : (
        <i className="fas fa-times-circle text-danger" style={{ fontSize: '1.1rem' }} />
      )}
      <small className="text-muted">Zoho</small>
    </span>
  );
};

const CloudActionButtons = ({ row, onPush, isPushing = false }) => {
    const isLocked = !!row?.cloud?.is_locked;
    const isSynced = !!row?.cloud?.is_updated && !!row?.cloud?.external_id;
    const totalMaterials = row?.cloud?.total_materials ?? 0;
    const syncedMaterials = row?.cloud?.synced_materials ?? 0;
    const syncProgressLabel = totalMaterials > 0
        ? `${syncedMaterials}/${totalMaterials} synced`
        : null;

    const syncProgressText = syncProgressLabel ? (
        <small className="text-muted text-nowrap">{syncProgressLabel}</small>
    ) : null;

    const zohoCloud = row?.zoho_cloud;

    if (isLocked) {
        return (
            <div className="d-flex align-items-center gap-2">
                <button
                    type="button"
                    className="btn btn-outline-secondary btn-sm"
                    disabled
                    title="Locked"
                >
                    <i className="fas fa-lock"></i>
                </button>
                {syncProgressText}
                <ZohoStatus zohoCloud={zohoCloud} />
            </div>
        );
    }

    if (isSynced) {
        return (
            <div className="d-flex align-items-center gap-2">
                <button
                    type="button"
                    className="btn btn-success btn-sm"
                    disabled
                    title="Synced"
                >
                    <i className="fas fa-cloud-upload-alt text-white"></i>
                </button>
                {syncProgressText}
                <ZohoStatus zohoCloud={zohoCloud} />
            </div>
        );
    }

    return (
        <div className="d-flex align-items-center gap-2">
            <button
                type="button"
                onClick={(event) => {
                    event.stopPropagation();
                    onPush?.(row);
                }}
                className="btn btn-secondary btn-sm"
                disabled={isPushing}
                title="Cloud Push"
            >
                {isPushing ? (
                    <i className="fas fa-spinner fa-spin text-white"></i>
                ) : (
                    <i className="fas fa-cloud-upload-alt text-white"></i>
                )}
            </button>
            {syncProgressText}
            <ZohoStatus zohoCloud={zohoCloud} />
        </div>
    );
};

export default CloudActionButtons;